export default __webpack_public_path__ + "static/media/nis_l.e1a8f0a2.jpg";